import http from '@/extensions/http'
import {api_error, ENDPOINTS, format_api_data} from '@/helpers'

export const form = {
    actions: {
        async send_job_alert(context, data) {
            try {
                await http.$post(ENDPOINTS.JOB_ALERT.STORE, format_api_data(data))
            } catch (exception) {
                if (exception.response) return api_error(exception.response)
            }
        }
    }
}